const ANNOTATION_SHAPE_TYPE = {
    POINT: 'POINT',
    POLYLINE: 'POLYLINE',
    POLYGON: 'POLYGON',
};
export { ANNOTATION_SHAPE_TYPE };
